module.exports = __webpack_public_path__ + "media/images/bank_images/paranabanco-d304fa9fcf9e066ae1ae2f94b8da1db9.png";